import Header from "./Header";
import Drawer from "./Drawer";
import { Toaster } from "react-hot-toast";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen h-full">
      <div className="flex flex-col">
        <Header />
        <div className="flex flex-col justify-center px-2 m-auto">
          {children}
          <div className="my-3" />
        </div>
      </div>
      <Drawer />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          success: {
            style: {
              background: "rgb(97, 155, 114)",
              color: "black",
            },
            iconTheme: {
              primary: "black",
              secondary: "rgb(97, 155, 114)",
            },
          },
        }}
      />
    </div>
  );
}
